import React, { useState, useEffect,useRef } from "react";
import * as styles from "./ContactForm.module.scss";
import FormInputs from "@components/ContactForm/FormInputs";

const API_ENDPOINT = process.env.LOCAL_DJANGO ? `http://127.0.0.1:8000` : `https://admin.magyk.cloud`;

const url = `${API_ENDPOINT}/api/attendee`;
const SignUpForm = () => {
    const form = useRef(null);

    async function postData(data){
        const response = await fetch(url,{
            method:'POST',
            mode: 'cors',
            headers:{

            },
            headers:{
                'Content-Type': "application/json",
            },
            body: form,

        }).then(
            console.log("posted form data")
        ).catch(e=>{
            console.log("error in posting form data", e);
        });

    }
    const submitForm= (e) => {
        e.preventDefault();
        const dataFromForm = new FormData(e.target)
        /* console.log("Sing up form submit ")
        for(const [k,v] of data){
            console.log(k,v);
        } */

        const data = {
            "name": dataFromForm.get("name"),
            "email": dataFromForm.get("email")
        }
        
        
        postData(data);


    }

    return (
        <section id="sign-up" style={{ marginBottom: "100px" }}>
            <h2 className={styles.contact_form_title}>RSVP!</h2>

            <form
                ref= {form}
                className={styles.form_grid}
                /* onSubmit={e=>submitForm(e)} */ /* This is for direct django api call */
                action="https://formspree.io/f/mzbyvzzr"
                method ="POST"
            >
                <div className={styles.form_inputs}>
                    <div className={styles.name}>
                        <label style={{ display: "block", lineHeight: "30px" }}>Name*</label>
                        <input type="text" name="FullName" placeholder="John Doe"  required />
                    </div>
                    <div className={styles.email}>
                        <label style={{ display: "block", lineHeight: "30px" }}>Email*</label>
                        <input
                            type="email"
                            name="Email"
                            placeholder="johndoe@mail.com"
                            required
                        />
                    </div>
                    <div className={styles.phone} style={{ display: "flex" }}>
                        <input type="tel" name="phone" placeholder="Phone" />
                    </div>
                    <div className={styles.company} style={{ display: "flex" }}>
                        <input type="text" name="company" placeholder="Company" />
                    </div>
                    <div className={styles.textarea}>
                        <textarea name="textarea" placeholder="Leave a message" />
                    </div>
                    <input type="submit" value="Submit" className={styles.submit}></input>
                </div>
                
            </form>
        </section>

    )
}

export default SignUpForm;